import { CountryCodes, type CountryCode } from '../entities/external/Country'

const LOWERCASE_WORDS = new Set(['and', 'of', 'the', 'to', 'in', 'for', 'with'])

const EXCEPTION_LABELS: Record<string, string> = {
  COTE_DIVOIRE: "Côte d'Ivoire",
  "KOREA_DEMOCRATIC_PEOPLE'S_REPUBLIC": "Democratic People's Republic of Korea",
  KOREA_REPUBLIC_OF: 'Republic of Korea',
  "LAO_PEOPLE'S_DEMOCRATIC_REPUBLIC": "Lao People's Democratic Republic",
  UNITED_KINGDOM_OF_GREAT_BRITAIN_AND_NORTHERN_IRELAND:
    'United Kingdom of Great Britain and Northern Ireland',
  UNITED_STATES_OF_AMERICA: 'United States of America',
  ÅLAND_ISLANDS: 'Åland Islands',
  SVALBARD_AND_JAN_MAYEN: 'Svalbard and Jan Mayen',
  BONAIRE_SINT_EUSTATIUS_AND_SABA: 'Bonaire, Sint Eustatius and Saba',
  FRENCH_SOUTHERN_TERRITORIES: 'French Southern Territories',
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: 'United States Minor Outlying Islands',
}

export const formatCountryLabel = (key: string) => {
  if (EXCEPTION_LABELS[key]) {
    return EXCEPTION_LABELS[key]
  }

  const words = key.replace(/_/g, ' ').toLowerCase().split(' ')

  return words
    .map((word) => {
      if (LOWERCASE_WORDS.has(word)) {
        return word
      } else {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      }
    })
    .join(' ')
}

const reversedMap: Record<CountryCode, string> = Object.entries(
  CountryCodes
).reduce(
  (acc, [key, value]) => {
    acc[value as CountryCode] = key
    return acc
  },
  {} as Record<CountryCode, string>
)

export const formatCountryLabelFromCode = (code: CountryCode) => {
  if (!code || !reversedMap[code]) {
    return ''
  }

  return formatCountryLabel(reversedMap[code])
}
